module.exports = __webpack_public_path__ + "img/sol-industriel-de-securite.ee9b134c.png";